import { FieldProps } from "../Field";
import APROptionalStepStatusLink from "@/APR/components/custom/OptionalStepStatusLink/OptionalStepStatusLink";
import { ConfigContext } from "@/core/contexts/ConfigContext";
import { FlowType } from "@/core/types/types";
import ALLOptionalStepStatusLink from "@/MIE/components/custom/OptionalStepStatusLink/OptionalStepStatusLink";
import { useContext } from "react";

// TODO: refactor so that condition is not needed and we have a generic component
const OptionalStepStatusLink = ({ field }: FieldProps) => {
  const initializationConfig = useContext(ConfigContext);

  if (
    initializationConfig.definitionName === FlowType.APR ||
    initializationConfig.definitionName === FlowType.APR_VAR
  ) {
    return <APROptionalStepStatusLink field={field} />;
  }

  return <ALLOptionalStepStatusLink field={field} />;
};

export default OptionalStepStatusLink;
